module.exports = __webpack_public_path__ + "img/toBePaid@3x.35e16012.png";